import DashboardPage from "./DashboardPage";
import { CompanyResults } from "../../components/Dashboard/CompanyResultsPanel";

export default function DashboardsByCompany() {
  return (
    <DashboardPage
      title="Resultados por empresa"
      subtitle="Nota por pilar e maturidade ESG de uma empresa"
      info="Escolha uma empresa no seletor. As barras comparam a nota de cada pilar com a nota de corte; a maturidade mostra o nível ESG por pilar."
    >
      <CompanyResults />
    </DashboardPage>
  );
}
